<template>
<div class="card-item"
  :id="item.itemId">
  <div class="card-item-heading">{{ item.heading }}</div>
  <div class="card-item-content">
    <div class="trade-connection"
      v-for="(stakeholder, index) in item.data.stakeholders"
      :index="index">
      <div class="input-item">
        <label for="">{{ item.heading }}名</label>
        <Input placeholder="取引先名"
          v-model="stakeholder.name" />
      </div>
      <div class="input-item">
        <label for="">所在地</label>
        <Input placeholder="◯◯県◯◯区"
          v-model="stakeholder.address" />
      </div>
      <div class="flex mt-harf">
        <div class="input-item">
          <label for="">シェア</label>
          <span class="parcent">
            <Input placeholder="00"
              :number="true"
              v-model.number="stakeholder.shareRate" />
          </span>
          <span>%</span>
        </div>
        <div class="input-item">
          <label for="">掛取引の割合</label>
          <span class="parcent">
            <Input :number="true"
              placeholder="00"
              v-model.number="stakeholder.salesOnCreditRate" />
          </span>
          <span>%</span>
        </div>
        <div class="input-item">
          <label for="">回収・支払の条件</label>
          <span>
            <Input placeholder="末日締め/翌月末払い"
              v-model="stakeholder.closingAndPayment" /></span>
        </div>
      </div>
      <div class="delete-item">
        <Button @click="destroyStakeholder(index)"
          shape="circle"
          icon="ios-trash-outline"></Button>
      </div>
    </div>
    <div class="add-item">
      <Button shape="circle"
        icon="md-add"
        @click="addStakeholder"></Button>
    </div>
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: ['item', 'groupIndex', 'itemIndex'],
  computed: {},
  mounted: function () {},
  methods: {
    addStakeholder: function () {
      this.$eventHub.$emit(
        'addItem',
        this.groupIndex,
        this.itemIndex,
        'stakeholders'
      )
    },
    destroyStakeholder: function (index) {
      this.$eventHub.$emit(
        'destroyItem',
        this.groupIndex,
        this.itemIndex,
        'stakeholders',
        index
      )
    }
  },
  watch: {}
}
</script>
